import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-olive-deep text-cream-light py-2 px-4 text-center text-xs md:text-sm font-light tracking-wide sticky top-0 z-50 border-b border-gold/20" data-id="element-20">
      <div className="flex items-center justify-center gap-3 max-w-4xl mx-auto" data-id="element-21">
        <div className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" data-id="element-22" />
        <p data-id="element-23">
          <span className="font-medium text-gold" data-id="element-24">
            Solo 153/500 copias a $17.990
          </span>{' '}
          <span className="opacity-60 mx-2" data-id="element-25">|</span> Después vuelve a $39.990
        </p>
      </div>
    </div>;
}